<ng-container *ngIf="!isFlowKrdya">
  <app-error-message-v2></app-error-message-v2>
</ng-container>

<ng-container *ngIf="isFlowKrdya">
  <app-error-message-v3></app-error-message-v3>
</ng-container>
